import { Suspense } from "react";
import { styled, Typography } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import { useUuidLayoutContext } from "hooks/routerHooks";

import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { AddMeasurePageSkeleton } from "components/skeletons/AddMeasurePageSkeleton";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";
import { AddMeasureConfigGuard } from "components/guards/AddMeasureConfigGuard";

export function AddMeasurePage() {
  const { t } = useTranslation();
  const { mapRef, footerRef, uuid, mapOverlayContainer } =
    useUuidLayoutContext();

  return (
    <StyledPaddedPaper>
      <Typography variant="h2" component="h1">
        {t("label.addAMeasure")}
      </Typography>
      <ErrorBoundary
        FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
      >
        <Suspense
          fallback={
            <AddMeasurePageSkeleton
              footerRef={footerRef}
              mapOverlayContainer={mapOverlayContainer}
            />
          }
        >
          <AddMeasureConfigGuard
            mapRef={mapRef}
            footerRef={footerRef}
            uuid={uuid}
          />
        </Suspense>
      </ErrorBoundary>
    </StyledPaddedPaper>
  );
}
const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  height: 100%;
`;
